import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import MoreThanSection from 'components/MoreThanSection'
import { ComponentRelatedFeature } from 'types/generated/contentful'
import { useThemeColor } from './ThemeContext'

export const RelatedFeature = ({
  headline,
  subheadline,
  featureName,
}: ComponentRelatedFeature): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='gray'>
      <SectionHeader
        title={headline!}
        subline={subheadline!}
        highlight={themeColor}
      />

      <MoreThanSection features={[featureName as any]} />
    </Section>
  )
}
